import styled from '@emotion/styled';
import Icon from '@icon/Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const MockTest = (props) => {
  const { color, fill, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 16 16" {...rest}>
      <path
        d="M5 14H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.5"
        stroke="#7A8B94"
        strokeWidth={1.22}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M9.755 13.808A.655.655 0 0 1 9.29 14h-1.32v-1.32c0-.174.069-.341.192-.464l3.882-3.886a1.128 1.128 0 0 1 1.595 0v0a1.127 1.127 0 0 1 0 1.596l-3.885 3.882Z"
        stroke="#7A8B94"
        strokeWidth={1.199}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m13.323 10.244.59.59c.31.31.31.814 0 1.125l-.714.715"
        stroke="#7A8B94"
        strokeWidth={1.199}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 8.334h2.5M5 6h6"
        stroke="#7A8B94"
        strokeWidth={1.22}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

export default MockTest;
